import { rockGemsApi } from "../../services/rockGemsApi";

export function fetchCategories({ force = false } = {}) {
  return async (dispatch, getState) => {
    const { categories } = getState();
    if (!force && categories.items?.length) return;

    dispatch({ type: "CATEGORIES/FETCH_START" });
    try {
      const data = await rockGemsApi.getCategories();
      dispatch({ type: "CATEGORIES/FETCH_SUCCESS", payload: data || [] });
    } catch (err) {
      dispatch({
        type: "CATEGORIES/FETCH_ERROR",
        payload: err?.message || "Failed to fetch categories"
      });
    }
  };
}

